export default __webpack_public_path__ + "static/media/start.8152b0e8.md";